// extracted by css-extract-rspack-plugin
export default {"cls1":"SearchUpsell-cls1_5Qr","cls2":"SearchUpsell-cls2_YL1 SearchUpsell-cls1_5Qr"};